import { N40, N30 } from '@atlaskit/theme/colors';
import { emojiPickerWidth } from './constants';
export var emojiPickerListWidth = emojiPickerWidth;
export var emojiPickerListHeight = 205;
export var emojiPickerBorderColor = "var(--ds-border, ".concat(N40, ")");
export var emojiPickerBoxShadow = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
export var noDialogContainerBorderColor = "var(--ds-border, ".concat(N40, ")");
export var noDialogContainerBorderRadius = "var(--ds-border-radius-100, 3px)";
export var noDialogContainerBoxShadow = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
export var akEmojiSelectedBackgroundColor = "var(--ds-background-neutral-subtle-hovered, ".concat(N30, ")");
export var emojiPreviewSelectedColor = "var(--ds-background-neutral, ".concat(N30, ")");
export var emojiTypeAheadMaxHeight = 350;
export var emojiTypeAheadWidth = 350;